import { Container, Row, Col } from 'react-bootstrap';

const Book = () => {
  return (
    <Container>
      <h1 className="mb-4">Book the Band</h1>
      
      <Row>
        <Col md={8}>
          <div className="mb-4">
            <p className="lead">
              East London Brass regularly performs concerts to a variety of audiences across London and further afield. 
              If you would be interested in booking the band for a concert, or would be interested in collaborating 
              with the band towards a joint project, please drop us an email for an initial discussion at{' '}
              <a href="mailto:eastlondonbrass@hotmail.com" className="text-accent">eastlondonbrass@hotmail.com</a>
            </p>
          </div>
        </Col>
        <Col md={4}>
          <div className="card">
            <div className="card-body">
              <h3 className="card-title">Contact Us</h3>
              <p className="card-text">
                <strong>Email:</strong> <a href="mailto:eastlondonbrass@hotmail.com" className="text-accent">eastlondonbrass@hotmail.com</a><br />
                <strong>Facebook:</strong> <a href="https://www.facebook.com/EastLondonBrass/" target="_blank" rel="noopener noreferrer" className="text-accent">@EastLondonBrass</a><br />
                <strong>Charity Number:</strong> 1091235<br />
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Book;
